import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1Civil1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/18Ela7f6gBdM_Vz9EPwtD_EX0dynh_wSR/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/18yp78riQdpm2IcLBfC9iztILoXEvfjNQ/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1JOZK7rNyi8t4MR-23SgkriNVeBKvL2fb/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">CIVIL Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1Civil1;
